import { Controller } from "react-hook-form";
import { Alert, Button, Card, Col, Form, Input, Row, Space, Tag } from "antd";
import Text from "antd/es/typography/Text";
import { IGiveaway } from "../../../../../interfaces";
import useProcessData from "./useProcessData";
import { EAwardStatus, EGiveawayStatus } from "../../../../../enums";
import { convertDataUSParaBrasilEHora } from "../../../../../utils/Conversores";
import ModalAwardWithWinner from "../../components/ModalAwardWithWinner";

interface IProps {
    giveaway: IGiveaway | undefined;
    refreshGiveaway: () => void;
    onClickShowTicketWinner: (awardId: number, attempt_number: number) => Promise<(() => void) | null | undefined>;
}

export default function ProcessData({ giveaway, onClickShowTicketWinner, refreshGiveaway }: IProps) {
    const {
        isSubmiting,
        control,
        handleSubmit,
        handleSubmitForm,
        errors,
        file,
        federalLottery,
        selectedAward,
        modalAwardVisible,
        handleCloseModalAwardWinner,
        onClickViewWinner
    } = useProcessData({ giveaway, refreshGiveaway });

    return (
        <Form
            onFinish={handleSubmit(handleSubmitForm)}
            autoComplete='off'
            layout='vertical'
        >
            {
                file && (
                    <>
                        <Col
                            span={24}
                        >
                            <Form.Item
                                label="Hash do arquivo com os participantes"
                                required
                                validateStatus={errors.hash ? 'error' : 'success'}
                                help={errors.hash?.message}
                            >
                                <Controller
                                    name="hash"
                                    disabled
                                    control={control}
                                    render={({ field }) =>
                                        <Input
                                            {...field}
                                            placeholder='Hash'
                                        />
                                    }
                                />
                            </Form.Item>
                        </Col>
                    </>
                )
            }

            {federalLottery && !federalLottery?.result && (
                <Row
                    style={{
                        marginBottom: 12,
                    }}
                >
                    <Alert
                        type="warning"
                        message="Alerta"
                        description="O sorteio ainda não tem um resultado oficial!"
                        style={{
                            width: '100%',
                        }}
                    />
                </Row>
            )}
            <Card>
                <Row style={{ alignItems: 'center' }}>
                    <Col span={6}>
                        <Row style={{ marginBottom: 10, alignItems: 'center' }}>

                            <Text style={{ fontWeight: 'bold', fontSize: 20 }}>
                                {giveaway?.description}
                            </Text>

                            <Tag style={{ marginLeft: 10 }} color={giveaway?.status === EGiveawayStatus.WAITING_RAFFLE ? "warning" : "default"}>{giveaway?.status}</Tag>
                        </Row>
                        <Row style={{ marginBottom: 2 }}>
                            <Text>
                                <strong>Data: </strong>
                                {giveaway?.date && convertDataUSParaBrasilEHora(giveaway?.date)}
                            </Text>
                        </Row>
                        <Row style={{ marginBottom: 2 }}>
                            <strong>Prêmios: </strong>
                        </Row>
                        <Row style={{ marginBottom: 12 }}>
                            {giveaway?.awards && giveaway.awards.map((award, index) => (

                                <Col key={index} span={24}>
                                    <Text style={{ fontSize: 14 }}>
                                        - {award.description}
                                    </Text>
                                </Col>

                            ))}
                        </Row>
                    </Col>
                    <Col span={14}>
                        <Row>
                            <Col span={24}>
                                <Text style={{ fontSize: 14, color: 'gray' }}>
                                    Números sorteados:
                                </Text>
                            </Col>
                            {giveaway && giveaway.awards && <Col span={24} >
                                <Row gutter={[6, 6]} style={{ marginBottom: 6 }}>
                                    {federalLottery?.result.map((result, index) => {
                                        const award = giveaway.awards?.[index];
                                        if (!award) {
                                            return <></>;
                                        }
                                        const lastAwardHistory = award.award_history && award.award_history[award.award_history.length - 1];


                                        return (<Col key={index}>
                                            <Space direction="vertical" size={0}
                                                style={{ paddingLeft: 4, paddingRight: 4, borderRadius: 4, backgroundColor: '#3a3a3aff' }}>
                                                <Text style={{ fontSize: 12, color: "#fff" }}>
                                                    {index + 1}° Prêmio - {award.description}
                                                </Text>
                                                <Text style={{ fontWeight: 'bold', fontSize: 40, color: "#fff" }}>
                                                    {result}
                                                </Text>
                                                {award.status !== EAwardStatus.valid && <Button disabled={lastAwardHistory?.status !== EAwardStatus.underAnalysis} onClick={() => onClickShowTicketWinner(award.id, lastAwardHistory?.attempt_number ?? 1)} type="primary" size="small" style={{ width: '100%', marginBottom: 4 }}>Ver bilhete</Button>}
                                                {award.status === EAwardStatus.valid && <Button onClick={() => onClickViewWinner(award)} size="small" style={{width: '100%', marginBottom: 4, backgroundColor: '#328E6E'}} type="primary">Ver ganhador</Button>}

                                            </Space></Col>)
                                    })}
                                </Row>
                            </Col>}


                        </Row>
                    </Col>
                    <Col>
                        {(giveaway?.status === EGiveawayStatus.WAITING_RAFFLE || giveaway?.status === EGiveawayStatus.WAITING_NEW_RAFFLE) && <Button
                            type="primary"
                            loading={isSubmiting}
                            disabled={federalLottery?.result.length === 0 || (giveaway?.status !== EGiveawayStatus.WAITING_RAFFLE && giveaway?.status !== EGiveawayStatus.WAITING_NEW_RAFFLE) || isSubmiting}
                            onClick={() => { }}
                            htmlType="submit"
                        >
                            Processar resultado
                        </Button>}
                    </Col>

                </Row>
            </Card>
            {selectedAward && <ModalAwardWithWinner award={selectedAward} visible={modalAwardVisible} onClose={handleCloseModalAwardWinner} />}
        </Form>
    )
}
